import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { CitationService } from '../../../service/citation/citation.service';
import { Attendance } from '../../../class/attendance';

@Component({
  selector: 'app-citation',
  templateUrl: './citation.component.html',
  styleUrls: ['./citation.component.scss']
})
export class CitationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoCitation: Attendance;
    public citation: Attendance;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public citationService: CitationService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelCitation () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/citations/citation/citation.component.ts